import { render } from "./PChatVideoAdd.vue?vue&type=template&id=f25341b0"
import script from "./PChatVideoAdd.vue?vue&type=script&lang=js"
export * from "./PChatVideoAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__